import * as React from 'react';
import Svg, { Rect } from 'react-native-svg';
const Copy = (props) => (<Svg viewBox="0 0 28 28" {...props}>
    <Rect width={28} height={28} rx={8} fill={props?.fill ?? '#D7EBF8'}/>
    <Rect x={7} y={7} width={10} height={10} rx={1} fill="transparent" stroke={props?.fill ?? '#3999DE'} strokeWidth={1.5} opacity={0.9}/>

    {/* Front page */}
    <Rect x={11} y={11} width={10} height={10} rx={1} fill="#D7EBF8" stroke={props?.fill ?? '#3999DE'} strokeWidth={1.5}/>
  </Svg>);
export default Copy;
